import { ApiResponse } from 'apisauce';

import type {
    Authentication,
    BusinessSignup,
    PasswordToken,
} from '@barboxx/models/types';

import { publicApi } from '../../publicApi';

// Business Users
export function login(userInfo: Authentication.UserLoginRequest) {
    return publicApi.post<Authentication.UserAuthReturn>(
        'auth/login',
        userInfo,
        {
            withCredentials: true,
        }
    );
}

let refreshTokenPromise: Promise<
    ApiResponse<Authentication.UserAuthReturn>
> | null = null;

export function refreshExpiredToken(
    query?: Authentication.RefreshTokenPayload
) {
    // Generated by Copilot
    if (!refreshTokenPromise) {
        refreshTokenPromise = publicApi
            .get<Authentication.UserAuthReturn>('auth/token', query, {
                withCredentials: true,
            })
            .finally(() => {
                refreshTokenPromise = null;
            });
    }
    return refreshTokenPromise;
}

export function logout() {
    return publicApi.get<undefined>('auth/logout', undefined, {
        withCredentials: true,
    });
}

export function businessSignup(signupInfo: BusinessSignup.CreateRequest) {
    return publicApi.post('auth/business/signup', signupInfo);
}

export function forgotPassword(userInfo: Authentication.ForgotPasswordRequest) {
    return publicApi.post('auth/password', userInfo);
}

export function resetPassword(data: PasswordToken.ResetPasswordRequest) {
    return publicApi.put('auth/password', data);
}
